module.exports = __webpack_public_path__ + "static/img/part2.fbb3f65.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/part2.png
// module id = TArW
// module chunks = 0